<div [ngStyle]="contentStyle" class="section h-100 password-forgot pointer-events-none">
  <div class="text-left h-100">
    <form
      class="is-space-between is-vertical-align h-100"
      style="align-items: stretch"
      [formGroup]="passwordForm"
    >
      <div>
        <finxone-input
          [type]="'email'"
          [name]="'email'"
          [label]="dataIn?.attri?.widgetProperties?.emailLabel"
          [placeholder]="dataIn?.attri?.widgetProperties?.emailPlaceHolder ?? ''"
          formControlName="email"
          [formControlInvalid]="
            !!(
              passwordForm.controls['email']?.dirty &&
              passwordForm.controls['email']?.invalid &&
              passwordForm.controls['email']?.touched
            )
          "
          [value]="passwordForm.controls['email']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'required',
              message: 'Field is mandatory'
            },
            {
              type: 'email',
              message: 'Enter valid email'
            }
          ]"
        >
        </finxone-input>
      </div>

      <finx-button
        (click)="enableSubmit = true; onSubmit()"
        type="button"
        [labeltext]="buttonContent"
        [buttonStyle]="!isAllowedGlobalStyling ? reviewDetailsButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
        [class.mandatory-cta-button]="!isAllowedGlobalStyling"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </form>
  </div>
</div>
